import { Dialog, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";

interface LoadingModalProps {
  isOpen: boolean;
}

export function LoadingModal({ isOpen }: LoadingModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      sx={{ zIndex: 1400 }}
      PaperProps={{
        style: {
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          boxShadow: "none",
          borderRadius: "16px",
          padding: "2rem",
        },
      }}
    >
      <DialogContent className="flex flex-col items-center p-8 min-w-[300px]">
        <div className="space-y-2 text-center">
          <p className="text-lg font-montserrat font-medium text-gray-800">
            {t("processing")}
          </p>
          <p className="text-sm font-montserrat text-gray-600">
            {t("please-wait")}
          </p>
        </div>

        <div className="mt-6 flex justify-center space-x-2">
          <div className="w-2 h-2 bg-[#EF0BB8] rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="w-2 h-2 bg-[#EF0BB8] rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="w-2 h-2 bg-[#EF0BB8] rounded-full animate-bounce"></div>
        </div>
      </DialogContent>
    </Dialog>
  );
}